export default __webpack_public_path__ + "static/media/central_andes_2_16.8bfe5679.JPG";